/*
*   Данные по магазинам для админов (то есть нас любимых)
*/
import router from '@/router/index';
import ajaxRequest from '@/utils/request';

const state = {
};

const getters = {
};

const actions = {
    changeCompany(context, company_id) {
        ajaxRequest({
            url: '/admins/company/change/',
            method: 'POST',
            params: {company_id},
            success(response) {
                document.location.reload();
            }
        });
    }
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/admins.js